import { useCallback, useMemo, useState } from "react";
import { Agreement } from "@/networking/agreements.api";

export function useAgreements(allAgreements: Agreement[]) {
  // Memoize the three filter buckets so their array references stay
  // stable across renders when `allAgreements` itself doesn't change.
  // Without this, `.filter` returns a new array on every render, which
  // propagates through useCallback/useMemo deps in consumers and
  // defeats their stability work.
  const requiredAgreements = useMemo(
    () => allAgreements.filter((a) => a.required),
    [allAgreements],
  );
  const optionalCheckboxAgreements = useMemo(
    () => allAgreements.filter((a) => !a.required && a.show_at_checkout),
    [allAgreements],
  );
  const footerAgreements = useMemo(
    () => allAgreements.filter((a) => !a.required && !a.show_at_checkout),
    [allAgreements],
  );

  const [optionalCheckedIds, setOptionalCheckedIds] = useState<number[]>([]);

  const getAcceptedAgreementIds = useCallback(() => {
    const requiredIds = requiredAgreements.map((a) => a.id);
    return [...requiredIds, ...optionalCheckedIds];
  }, [requiredAgreements, optionalCheckedIds]);

  return {
    requiredAgreements,
    optionalCheckboxAgreements,
    footerAgreements,
    optionalCheckedIds,
    setOptionalCheckedIds,
    getAcceptedAgreementIds,
  };
}
